import { z } from 'zod';
import { baseModelSchema } from '../../baseModel';
import { IPackCategoryFormValues } from './packCategoryFormValues';

/**
 * Zod schema for validating pack category data.
 * Extends the base model schema with pack category-specific fields.
 * Represents a classification category for packs in the system.
 *
 * @property {string} code - Unique identifier code (max 5 characters)
 * @property {string} category - Name of the category (max 255 characters)
 */
export const packCategorySchema = baseModelSchema.extend({
    code: z.string().max(5, 'Code can only be up to 5 characters long.').optional().nullable().default(''),
    category: z.string().nonempty('Category is required').max(255, 'Category can only be up to 255 characters long.').default(''),
});

/**
 * TypeScript interface representing a PackCategory object.
 * Generated from the Zod schema for type safety.
 */
export type IPackCategory = z.infer<typeof packCategorySchema>;

/**
 * Creates a validated PackCategory object from form values.
 *
 * @param {IPackCategoryFormValues} formValues - The form data to convert
 * @returns {IPackCategory} A validated pack category object
 * @throws {ZodError} If validation fails
 */
export function PackCategory(formValues : IPackCategoryFormValues) : IPackCategory {
    return packCategorySchema.parse({
        ...formValues,
    });
}
